var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReverseMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 854,
    height: 790,
    viewBox: "0 0 854 790",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.15003 469.81H852.21V592.31L779.46 543.81L673.75 589.2L566.8 543.81L474.15 630.24L374.04 658.84L329.89 622.15L295.07 569.29L262.11 601L188.73 539.44L137.74 546.9L80.53 497.78L6.53003 479.13L7.15003 469.8V469.81Z",
    fill: "#384252",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M706.86 482.05H655.47V619.39H706.86V482.05Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M655.86 463.49H706.59L706.48 482.57L655.8 492.35L655.86 463.49Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M664.33 490.76V509.45L698.24 502.14V484.11L664.33 490.76Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M674.77 507.25V558.58L681.2 548.63L687.19 552.92V504.61L674.77 507.25Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M655.79 619.44L666.88 619.87V681.93L675.41 685.56L676.26 684.07L686.5 684.5L687.57 685.35L694.39 682.37L695.03 681.09L695.65 619.64H706.51V763.65H655.84L655.79 619.46V619.44Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M655.66 619.83H664.37L664.45 682.37L681.15 686.78L698.27 680.97V619.79H706.56V763.76H655.74L655.66 619.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M655.7 492.35V763.75H706.54V482.51",
    fill: "#131F2E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M655.7 492.35V763.75H706.54V482.51",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M664.38 509.34V730.29V509.34Z",
    fill: "#131F2E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M664.38 509.34V730.29",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M698.19 502.14V730.01V502.14Z",
    fill: "#131F2E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M698.19 502.14V730.01",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M675.16 730.17V721.49H666.81V576.66H664.37",
    fill: "#131F2E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M675.16 730.17V721.49H666.81V576.66H664.37",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M698.18 576.7H695.62V721.5H687.29V729.91",
    fill: "#131F2E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M698.18 576.7H695.62V721.5H687.29V729.91",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M681.37 565.88L686.08 570.59V619.75H687.66V632.12H674.73V619.68H676.39V572.52L681.37 565.89V565.88Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M675.33 634.15L667.94 640.71V682.33L674.99 685.35",
    fill: "#131F2E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M675.33 634.15L667.94 640.71V682.33L674.99 685.35",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M687.25 634.15L694.64 640.71V682.33L687.59 685.35",
    fill: "#131F2E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M687.25 634.15L694.64 640.71V682.33L687.59 685.35",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M675.37 664.69L667.91 667.14L675.37 664.69Z",
    fill: "#131F2E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M675.37 664.69L667.91 667.14",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M687.21 664.69L694.67 667.14L687.21 664.69Z",
    fill: "#131F2E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M687.21 664.69L694.67 667.14",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M666.85 709.44H675.41H666.85Z",
    fill: "#131F2E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M666.85 709.44H675.41",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M686.87 709.44H695.43H686.87Z",
    fill: "#131F2E"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M686.87 709.44H695.43",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M687.25 714.94C687.25 718.25 684.57 720.93 681.26 720.93C677.95 720.93 675.27 718.25 675.27 714.94C675.27 711.63 677.95 708.95 681.26 708.95C684.57 708.95 687.25 711.63 687.25 714.94Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M687.28 680.14C687.28 683.45 684.6 686.13 681.29 686.13C677.98 686.13 675.3 683.45 675.3 680.14C675.3 676.83 677.98 674.15 681.29 674.15C684.6 674.15 687.28 676.83 687.28 680.14Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M655.73 729.6L607.48 735.03L655.73 738.65V729.6Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M655.73 748.91L607.48 754.34L655.73 757.96V748.91Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M706.7 748.91L754.95 754.34L706.7 757.96V748.91Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M706.7 729.6L754.95 735.03L706.7 738.65V729.6Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M655.88 463.3H653.32V466.01H655.88V463.3Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M675.18 463.3H672.62V466.01H675.18V463.3Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M689.96 463.3H687.4V466.01H689.96V463.3Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M709.71 463.3H707.15V466.01H709.71V463.3Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M709.86 450.94H707.3V453.65H709.86V450.94Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M690.11 450.94H687.55V453.65H690.11V450.94Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M675.18 450.79H672.62V453.5H675.18V450.79Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M656.03 451.09H653.47V453.8H656.03V451.09Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M664.33 453.35V437.82H698.11V453.65L664.33 453.35Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M652.18 453.49L652.29 463.27H710.11V453.49H652.18Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M652.13 458.44L710.23 458.55L652.13 458.44Z",
    fill: "#131F2E"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M652.13 458.44L710.23 458.55",
    stroke: "#F7F9F9"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M726.85 421.03V417.46H731.17V421.03H726.85Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M699.23 419.89H708.93L710.32 422.34H723.12V421.06H735.06L735.54 423.14H749.03L745.24 430.6H735.64L734.31 432.09H723.7L722.69 430.81H709.89V434.22H699.33L699.22 419.88L699.23 419.89Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M661.98 437.92L699.31 437.97V416.1H662.06L661.98 437.91V437.92Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M670.91 416.03H668.35V418.74H670.91V416.03Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M666.76 407.5H664.2V410.21H666.76V407.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M699.38 407.34H696.82V410.05H699.38V407.34Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M694 415.87H691.44V418.58H694V415.87Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M660.69 409.81V416.37H701.79V409.81H660.69Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M660.79 412.96H701.74H660.79Z",
    fill: "#131F2E"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M660.79 412.96H701.74",
    stroke: "#F7F9F9"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M710.27 422.23C710.27 422.23 708.99 426.23 710.06 430.92L710.27 422.23Z",
    fill: "#131F2E"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M710.27 422.23C710.27 422.23 708.99 426.23 710.06 430.92",
    stroke: "#F7F9F9"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M723.01 422.28C723.01 422.28 722.16 425.58 723.01 430.97V422.28Z",
    fill: "#131F2E"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M723.01 422.28C723.01 422.28 722.16 425.58 723.01 430.97",
    stroke: "#F7F9F9"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M735.59 423.3C735.59 423.3 734.74 426.6 735.64 430.5L735.59 423.3Z",
    fill: "#131F2E"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M735.59 423.3C735.59 423.3 734.74 426.6 735.64 430.5",
    stroke: "#F7F9F9"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M734.58 412.48C734.58 415.57 732.08 418.08 728.99 418.09C725.9 418.09 723.39 415.59 723.38 412.5V412.48C723.38 409.39 725.88 406.88 728.97 406.87C732.06 406.87 734.57 409.37 734.58 412.46V412.48Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M724.19 415.01L725.63 414.4L724.19 415.01Z",
    fill: "#131F2E"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M724.19 415.01L725.63 414.4",
    stroke: "#F7F9F9"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M723.49 412.98L724.96 412.9L723.49 412.98Z",
    fill: "#131F2E"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M723.49 412.98L724.96 412.9",
    stroke: "#F7F9F9"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M723.79 410.67L725.1 411.12L723.79 410.67Z",
    fill: "#131F2E"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M723.79 410.67L725.1 411.12",
    stroke: "#F7F9F9"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M725.01 408.61L726 409.57L725.01 408.61Z",
    fill: "#131F2E"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M725.01 408.61L726 409.57",
    stroke: "#F7F9F9"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M728.95 413.45L725.32 409.17L726.46 408.25L729.89 412.58L728.95 413.46V413.45Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M726.77 407.31L727.33 408.59L726.77 407.31Z",
    fill: "#131F2E"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M726.77 407.31L727.33 408.59",
    stroke: "#F7F9F9"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M729.94 412.52C729.94 413.01 729.55 413.4 729.07 413.41C728.58 413.41 728.19 413.02 728.18 412.54C728.18 412.04 728.57 411.64 729.05 411.64C729.54 411.64 729.93 412.03 729.94 412.51V412.52Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M729.04 406.91L729.01 408.3L729.04 406.91Z",
    fill: "#131F2E"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M729.04 406.91L729.01 408.3",
    stroke: "#F7F9F9"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M733.9 415.01L732.46 414.4L733.9 415.01Z",
    fill: "#131F2E"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M733.9 415.01L732.46 414.4",
    stroke: "#F7F9F9"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M734.6 412.98L733.13 412.9L734.6 412.98Z",
    fill: "#131F2E"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M734.6 412.98L733.13 412.9",
    stroke: "#F7F9F9"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M734.3 410.67L732.99 411.12L734.3 410.67Z",
    fill: "#131F2E"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M734.3 410.67L732.99 411.12",
    stroke: "#F7F9F9"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M733.08 408.61L732.09 409.57L733.08 408.61Z",
    fill: "#131F2E"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M733.08 408.61L732.09 409.57",
    stroke: "#F7F9F9"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M731.32 407.31L730.76 408.59L731.32 407.31Z",
    fill: "#131F2E"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M731.32 407.31L730.76 408.59",
    stroke: "#F7F9F9"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M734.58 412.48C734.58 415.57 732.08 418.08 728.99 418.09C725.9 418.09 723.39 415.59 723.38 412.5V412.48C723.38 409.39 725.88 406.88 728.97 406.87C732.06 406.87 734.57 409.37 734.58 412.46V412.48Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M673.84 409.82V389.69H670.33V385.77H690.23V389.8H686.42V409.82H673.83H673.84Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M680.43 385.76V196.95V385.76Z",
    fill: "#131F2E"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M680.43 385.76V196.95",
    stroke: "#F7F9F9",
    strokeWidth: 3
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M127.34 449.39L127.12 391.57C127.07 384.6 130.19 378.62 137.89 374.2L259.69 306.27C270.09 309.91 277.39 315.63 277.28 326.28L265.63 378.38L190 444.99L177.03 445.43L175.71 450.71L127.34 449.39Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M462.88 165.83V170.57C464.17 171.6 464.92 171.17 465.6 170.57V165.83H462.88Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M504.16 165.79V170.53C505.45 171.56 506.2 171.13 506.88 170.53V165.79H504.16Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M350.91 157.3L351.07 160.1L370.93 167.41L374.08 166.28L373.15 164.22L351.54 156.33L350.92 157.3H350.91Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M638.88 132.85L348.49 133.16L348.65 156.48L373.37 165.5L643.24 166.12L638.89 132.85H638.88Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M651.23 84.96L636.39 130.35L654.3 258.6C656.21 262.75 658.59 262.87 660.91 263.42C668.18 246.21 675.7 229.91 680.27 202.48C680.7 167.8 682.84 133.41 664.14 95.53L651.23 84.96Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2.04
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M662.67 112.48C662.67 113.85 661.56 114.97 660.18 114.97C658.8 114.97 657.69 113.86 657.69 112.48C657.69 111.1 658.8 109.99 660.18 109.99C661.56 109.99 662.67 111.1 662.67 112.48Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M660.33 249.59C660.33 250.79 659.36 251.77 658.15 251.77C656.94 251.77 655.97 250.8 655.97 249.59C655.97 248.38 656.94 247.41 658.15 247.41C659.36 247.41 660.33 248.38 660.33 249.59Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M500.29 172.02V174.9C499.74 175.56 499.26 176.44 498.11 174.9L498.5 171.4L500.29 172.02Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M469.28 172.18V175.06C469.83 175.72 470.31 176.6 471.46 175.06L471.07 171.56L469.28 172.18Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M469.12 165.72V172.4L482.02 178.07L487.38 178.3L500.44 172.16V165.94L469.11 165.71L469.12 165.72Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M478.6 176.76L476.42 187.33L493.44 187.56L490.33 174.81L478.59 176.75L478.6 176.76Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M484.75 187.41V181.58V187.41Z",
    fill: "#131F2E"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M484.75 187.41V181.58",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M491.74 176.22C491.74 180.13 488.57 183.29 484.67 183.29C480.77 183.29 477.6 180.12 477.6 176.22C477.6 172.32 480.77 169.15 484.67 169.15C488.57 169.15 491.74 172.32 491.74 176.22Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M488.09 176.37C488.09 178.39 486.45 180.02 484.44 180.02C482.43 180.02 480.79 178.38 480.79 176.37C480.79 174.36 482.43 172.72 484.44 172.72C486.46 172.72 488.09 174.36 488.09 176.37Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M476.89 184.85H492.75H476.89Z",
    fill: "#131F2E"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M476.89 184.85H492.75",
    stroke: "#F7F9F9"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M453.42 215.08H494.46L493.84 190.13H470.05L453.42 215.08Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M466.79 211.66C466.79 212.48 466.13 213.14 465.31 213.14C464.49 213.14 463.83 212.48 463.83 211.66C463.83 210.84 464.49 210.18 465.31 210.18C466.13 210.18 466.79 210.84 466.79 211.66Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M460.34 211.51C460.34 212.33 459.68 212.99 458.86 212.99C458.04 212.99 457.38 212.33 457.38 211.51C457.38 210.69 458.04 210.03 458.86 210.03C459.68 210.03 460.34 210.69 460.34 211.51Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M463.84 206.14C463.84 206.96 463.18 207.62 462.36 207.62C461.54 207.62 460.88 206.96 460.88 206.14C460.88 205.32 461.54 204.66 462.36 204.66C463.18 204.66 463.84 205.32 463.84 206.14Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M470.21 206.14C470.21 206.96 469.55 207.62 468.73 207.62C467.91 207.62 467.25 206.96 467.25 206.14C467.25 205.32 467.91 204.66 468.73 204.66C469.55 204.66 470.21 205.32 470.21 206.14Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M467.18 201.01C467.18 201.83 466.52 202.49 465.7 202.49C464.88 202.49 464.22 201.83 464.22 201.01C464.22 200.19 464.88 199.53 465.7 199.53C466.52 199.53 467.18 200.19 467.18 201.01Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M473.63 201.17C473.63 201.99 472.97 202.65 472.15 202.65C471.33 202.65 470.67 201.99 470.67 201.17C470.67 200.35 471.33 199.69 472.15 199.69C472.97 199.69 473.63 200.35 473.63 201.17Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M470.68 195.81C470.68 196.63 470.02 197.29 469.2 197.29C468.38 197.29 467.72 196.63 467.72 195.81C467.72 194.99 468.38 194.33 469.2 194.33C470.02 194.33 470.68 194.99 470.68 195.81Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M477.21 196.12C477.21 196.94 476.55 197.6 475.73 197.6C474.91 197.6 474.25 196.94 474.25 196.12C474.25 195.3 474.91 194.64 475.73 194.64C476.55 194.64 477.21 195.3 477.21 196.12Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M473.94 190.75C473.94 191.57 473.28 192.23 472.46 192.23C471.64 192.23 470.98 191.57 470.98 190.75C470.98 189.93 471.64 189.27 472.46 189.27C473.28 189.27 473.94 189.93 473.94 190.75Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M480.78 190.75C480.78 191.57 480.12 192.23 479.3 192.23C478.48 192.23 477.82 191.57 477.82 190.75C477.82 189.93 478.48 189.27 479.3 189.27C480.12 189.27 480.78 189.93 480.78 190.75Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M483.42 188.65L528.66 443.29L540.01 443.45L493.68 188.66H483.42V188.65Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M495.94 187.26H469.2V189.82H495.94V187.26Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M356.7 165.28L354.48 165.38C353.31 164.34 352.27 164.65 351.1 161.77C350.9 161.13 350.89 160.51 351.1 159.9C351.86 159.84 352.61 159.76 353.52 159.9C354.87 160.17 355.94 160.79 356.82 161.55L356.71 165.29L356.7 165.28Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M354.78 165.45L353.35 168.64C353.12 171.09 355.42 170.65 356.87 170.73L356.73 165.37L354.78 165.45Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M356.87 166.62C359.84 167.55 362.78 168.35 365.88 170.12C365.83 170.78 366.37 171.79 365.33 171.85L356.15 171.88L356.95 171.61L356.97 170.73L356.86 166.62H356.87Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M356.87 161.55L359.62 161.66C363.5 163.34 367.52 164.97 370.56 166.94C371.62 170.03 370.19 170.52 368.86 171.12L365.73 170.02C363.18 168.33 359.97 167.64 357.05 166.5L356.88 161.55H356.87Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M372.35 172.18C380.63 171.23 388.9 170.27 393.34 168.92C394.93 167.84 394.1 166.55 393.26 165.27L374.14 165.5L370.95 166.9L372.35 172.19V172.18Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M368.15 174.24L368.19 170.74L370.99 167.13C371.62 167.38 372.27 167.4 372.51 172.69C371.8 174.38 371.04 175.84 370.02 175.99C369.04 175.83 368.52 175.12 368.15 174.24Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M356.25 171.58L351.63 174.88V192.03L353.17 194.12L352.95 208.63L356.8 210.17H364.82L367.79 208.63L368.23 194.45L369.99 192.58V174.44L366.14 171.58H356.24H356.25Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M453.39 214.56L344.26 379.03L356.7 379.19L465.68 214.41L453.4 214.57L453.39 214.56Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M427.2 335.03L426.89 325.39C427.03 323.24 425.85 323.4 424.87 323.21L421.92 323.37L420.83 309.22C409.79 289.63 402.49 278.86 392.23 278.75C376.18 278.77 371.26 300.83 359.58 316.21L361.29 331.6L366.73 335.95L427.2 335.02V335.03Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M356.93 180.13L365.95 180.209L356.93 180.13Z",
    fill: "#131F2E"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M356.93 180.13L365.95 180.209",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M356.54 188.91L365.79 189.07L356.54 188.91Z",
    fill: "#131F2E"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M356.54 188.91L365.79 189.07",
    stroke: "#F7F9F9"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M356.47 196.3C360.54 204.99 362.89 202.68 365.8 196.3H356.47Z",
    fill: "#131F2E"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M356.47 196.3C360.54 204.99 362.89 202.68 365.8 196.3",
    stroke: "#F7F9F9"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M417.82 319.29C417.82 321.41 416.1 323.14 413.97 323.14C411.85 323.14 410.12 321.42 410.12 319.29C410.12 317.16 411.84 315.44 413.97 315.44C416.09 315.44 417.82 317.16 417.82 319.29Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M415.4 319.4C415.4 320.19 414.76 320.83 413.97 320.83C413.18 320.83 412.54 320.19 412.54 319.4C412.54 318.61 413.18 317.97 413.97 317.97C414.76 317.97 415.4 318.61 415.4 319.4Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M377.25 320.83C377.25 322.95 375.53 324.68 373.4 324.68C371.28 324.68 369.55 322.96 369.55 320.83C369.55 318.7 371.27 316.98 373.4 316.98C375.52 316.98 377.25 318.7 377.25 320.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M374.83 320.94C374.83 321.73 374.19 322.37 373.4 322.37C372.61 322.37 371.97 321.73 371.97 320.94C371.97 320.15 372.61 319.51 373.4 319.51C374.19 319.51 374.83 320.15 374.83 320.94Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M395.17 285.77C395.17 287.89 393.45 289.62 391.32 289.62C389.2 289.62 387.47 287.9 387.47 285.77C387.47 283.64 389.19 281.92 391.32 281.92C393.45 281.92 395.17 283.64 395.17 285.77Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M392.75 285.88C392.75 286.67 392.11 287.31 391.32 287.31C390.53 287.31 389.89 286.67 389.89 285.88C389.89 285.09 390.53 284.45 391.32 284.45C392.11 284.45 392.75 285.09 392.75 285.88Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M398.08 317.26H386.32V324.41H398.08V317.26Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M401.82 330.45L401.71 324.84C402.68 321.01 408.94 320.73 410.17 324.84V330.56L401.82 330.45Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M407.21 326.71C407.21 327.44 406.62 328.03 405.89 328.03C405.16 328.03 404.57 327.44 404.57 326.71C404.57 325.97 405.16 325.38 405.89 325.38C406.62 325.38 407.21 325.97 407.21 326.7V326.71Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M428.21 357.04L428.4 366.68C428.65 368.82 427.47 368.72 426.49 368.96H423.53L423.17 383.14C413.15 403.28 406.42 414.41 396.18 415.05C380.15 415.86 374.1 394.08 361.64 379.32L361.62 363.78L367.76 359.23L428.2 357.04H428.21Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M187.84 466.53C187.84 466.53 213.84 458.44 222.24 443.01L238.73 378.69C240.32 375.01 244.01 369.93 253.68 368.1L266.36 367.98",
    fill: "#131F2E"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M187.84 466.53C187.84 466.53 213.84 458.44 222.24 443.01L238.73 378.69C240.32 375.01 244.01 369.93 253.68 368.1L266.36 367.98",
    stroke: "#F7F9F9",
    strokeWidth: 3.92
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M110.74 449.48H253.86C253.92 449.48 253.97 449.53 253.97 449.59V469.6C253.97 469.66 253.92 469.71 253.86 469.71H110.74C110.68 469.71 110.63 469.66 110.63 469.6V449.59C110.63 449.53 110.68 449.48 110.74 449.48Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M336.03 376.67V367.88L334.64 367.51L334.49 356.78L332.51 334.36V325.35H328.77V327H318.22V324.69L305.03 324.58C304.81 325.24 304.81 327 304.81 327H290.19V324.69H276.78V326.67H266.56V325.24H262.49L259.74 341.95V363.38L258.53 363.06V364.04L259.68 364.7L259.85 367.23L262.82 368.55V376.57L336.03 376.68V376.67Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M290.17 376.93L303.25 354.73L321.61 354.95L333.26 376.83",
    fill: "#131F2E"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M290.17 376.93L303.25 354.73L321.61 354.95L333.26 376.83",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M307.8 333.9C304.86 337.71 302.12 342.31 300.62 350.45C302.55 356.02 305.29 361.09 308.68 366.66L428.5 361.82C429.54 351.9 430.4 341.84 428.28 329.61L307.8 333.9Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M289.62 355.93H303.58H289.62Z",
    fill: "#131F2E"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M289.62 355.93H303.58",
    stroke: "#F7F9F9"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M292.92 349.89H301.6H292.92Z",
    fill: "#131F2E"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M292.92 349.89H301.6",
    stroke: "#F7F9F9"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M289.57 343.62H302.92H289.57Z",
    fill: "#131F2E"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M289.57 343.62H302.92",
    stroke: "#F7F9F9",
    strokeWidth: 1.02
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M302.95 342.5L327.59 342.58V357.57H303.81L300.71 350.26L302.95 342.51V342.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M351.68 349.73L338.16 348.64C331.71 348.41 331.26 357.2 337.23 357.73L350.99 358.58L351.69 349.72L351.68 349.73Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M419.65 373.24C419.54 371.12 417.73 369.49 415.61 369.6C413.49 369.71 411.86 371.52 411.97 373.64C412.08 375.76 413.89 377.4 416.01 377.29C418.13 377.18 419.76 375.37 419.65 373.25V373.24Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M351.75 336.59L348.95 356.33C349.11 370.95 371.59 370.69 371.02 355.71L366.9 336.35L351.74 336.58L351.75 336.59Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M356.17 171.5L354.91 345.96L364.58 346L365.38 171.46L356.16 171.5H356.17Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M302.75 342.36L327.37 342.14L327.84 357.32L303.99 357.84",
    fill: "#131F2E"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M302.75 342.36L327.37 342.14L327.84 357.32L303.99 357.84",
    stroke: "#F7F9F9"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M317.26 350.17C317.26 353.21 314.8 355.67 311.77 355.67C308.73 355.67 306.27 353.21 306.27 350.18C306.27 347.14 308.73 344.67 311.76 344.67C314.79 344.67 317.26 347.13 317.26 350.16V350.17Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M319.67 350.28C319.67 351.37 318.78 352.26 317.69 352.26C316.6 352.26 315.71 351.37 315.71 350.28C315.71 349.19 316.6 348.3 317.69 348.3C318.78 348.3 319.67 349.18 319.67 350.28Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M417.23 373.25C417.19 372.46 416.52 371.85 415.73 371.9C414.94 371.94 414.33 372.61 414.38 373.4C414.42 374.19 415.09 374.8 415.88 374.76C416.67 374.72 417.27 374.05 417.23 373.26V373.25Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M367.3 356.02C367.3 360.18 363.92 363.56 359.76 363.56C355.6 363.56 352.22 360.18 352.22 356.02C352.22 351.86 355.6 348.48 359.76 348.48C363.92 348.48 367.3 351.86 367.3 356.02Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M379.07 373.79C378.96 371.67 377.15 370.04 375.03 370.15C372.91 370.26 371.28 372.07 371.39 374.19C371.5 376.31 373.31 377.95 375.43 377.84C377.55 377.73 379.18 375.92 379.07 373.8V373.79Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M364.43 355.94C364.43 358.56 362.32 360.69 359.7 360.69C357.08 360.69 354.95 358.58 354.95 355.96V355.94C354.95 353.32 357.06 351.19 359.68 351.19C362.3 351.19 364.43 353.3 364.43 355.92V355.94Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinejoin: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M376.64 373.81C376.6 373.02 375.93 372.41 375.14 372.46C374.35 372.5 373.74 373.17 373.79 373.96C373.83 374.75 374.5 375.36 375.29 375.32C376.08 375.28 376.68 374.61 376.64 373.82V373.81Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M362.33 355.94C362.33 357.36 361.19 358.51 359.77 358.51C358.35 358.51 357.2 357.37 357.2 355.95C357.2 354.52 358.34 353.37 359.76 353.37C361.18 353.37 362.33 354.51 362.33 355.93V355.94Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M346.7 353.61C346.7 354.73 345.8 355.63 344.68 355.63C343.56 355.63 342.66 354.73 342.66 353.61C342.66 352.49 343.56 351.59 344.68 351.59C345.8 351.59 346.7 352.49 346.7 353.61Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinejoin: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M339.86 352.91C339.86 354.11 338.89 355.09 337.69 355.09C336.49 355.09 335.51 354.12 335.51 352.92C335.51 351.71 336.48 350.74 337.68 350.74C338.88 350.74 339.86 351.71 339.86 352.91Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinejoin: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M398.77 407.89C398.66 405.77 396.85 404.14 394.73 404.25C392.61 404.36 390.98 406.17 391.09 408.29C391.2 410.42 393.01 412.05 395.13 411.94C397.25 411.83 398.88 410.02 398.77 407.9V407.89Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M396.35 407.9C396.31 407.11 395.64 406.51 394.85 406.55C394.06 406.59 393.46 407.26 393.5 408.05C393.54 408.84 394.21 409.45 395 409.41C395.79 409.37 396.39 408.7 396.35 407.91V407.9Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M399.645 369.199L387.901 369.806L388.27 376.947L400.015 376.339L399.645 369.199Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M403.1 362.92L403.28 368.52C404.45 372.29 410.71 372.25 411.73 368.08L411.43 362.37L403.09 362.91L403.1 362.92Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M408.68 366.37C408.64 365.64 408.03 365.08 407.3 365.12C406.57 365.16 406.01 365.77 406.05 366.5C406.09 367.23 406.7 367.79 407.43 367.75C408.16 367.71 408.72 367.1 408.68 366.37Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M262.77 371.89H264.2V370.35H278.22V369.47H279.1V363.75L274.7 359.9L259.75 360.01L259.91 363.58L258.48 363.03L258.64 364.18L259.74 364.9L259.9 367.26L262.81 368.58L262.76 371.88L262.77 371.89Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M256.8 338.75C255.55 339.01 254.28 339.18 252.95 338.86C252.29 338.95 252.05 338.54 251.74 338.2C251.45 337.05 251.38 335.95 251.96 335.01C255.33 333.39 258.7 333.29 262.07 332.59C264.68 332.62 267.31 332.82 269.98 333.36C271 333.93 271.67 334.63 271.74 335.56L271.3 337.65L267.34 336.88L264.26 336.33L260.63 336C259.22 336.78 257.52 337.23 256.78 338.75H256.8Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M264.25 337.54L264.03 336.36C264.96 335.76 266.37 335.64 266.5 334.24L266.66 331.85C266.53 330.86 268.94 330.7 269.08 331.8V335.37C268.85 336.44 268.09 337.06 267.02 337.43L264.35 337.71L264.24 337.55L264.25 337.54Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M280.94 350.33C280.94 357.68 274.99 363.63 267.64 363.63C260.29 363.63 254.34 357.67 254.34 350.33C254.34 342.99 260.3 337.03 267.64 337.03C274.98 337.03 280.94 342.99 280.94 350.33Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinejoin: "round"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M278.3 350.33C278.3 356.22 273.53 360.99 267.64 360.99C261.75 360.99 256.98 356.22 256.98 350.33C256.98 344.44 261.75 339.67 267.64 339.67C273.53 339.67 278.3 344.44 278.3 350.33Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinejoin: "round"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M275.33 350.22C275.33 354.41 271.93 357.8 267.75 357.8C263.57 357.8 260.17 354.4 260.17 350.22C260.17 346.04 263.57 342.64 267.75 342.64C271.93 342.64 275.33 346.04 275.33 350.22Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinejoin: "round"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M270.06 350.22C270.06 351.56 268.98 352.64 267.64 352.64C266.3 352.64 265.22 351.56 265.22 350.22C265.22 348.88 266.3 347.8 267.64 347.8C268.98 347.8 270.06 348.88 270.06 350.22Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinejoin: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M292.81 349.89C292.81 354.08 289.42 357.48 285.23 357.48C281.04 357.48 277.64 354.09 277.64 349.9V349.88C277.64 345.69 281.03 342.29 285.22 342.29C289.41 342.29 292.81 345.68 292.81 349.87C292.81 349.87 292.81 349.88 292.81 349.89Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinejoin: "round"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M280.01 363.08H282.11V362.05H283.76L283.73 364.96H282.15L282.12 363.8H280.02V363.07L280.01 363.08Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M278.13 363.12H274.89V366.75H278.13V363.12Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinejoin: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M280.41 362.22H277.11V364.69H280.41V362.22Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinejoin: "round"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M265.57 365.68C265.73 367.49 265.57 367.77 265.57 367.77H266.89V370.08H274.04V371.4H276.62V365.57L265.57 365.68Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M339.17 377.06H259.36V380.36H339.17V377.06Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinejoin: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M285.41 376.95L285.52 380.69L285.41 376.95Z",
    fill: "#131F2E"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M285.41 376.95L285.52 380.69",
    stroke: "#F7F9F9"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M356.97 378.6H340.92V380.91H356.97V378.6Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinejoin: "round"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M259.47 380.41V443.29H374.45L357.08 380.41H259.47Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M295.42 380.47H292.78V394.76H295.42V380.47Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinejoin: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M307.4 380.58H304.76V394.87H307.4V380.58Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinejoin: "round"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M319.6 380.47H316.96V394.76H319.6V380.47Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinejoin: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M331.8 380.47H329.16V394.76H331.8V380.47Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinejoin: "round"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M112.23 438.07V425.8L109.72 427.98V438.65L112.23 438.07Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.85
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M171.94 449.23V423.47H184.47V449.36L171.94 449.23Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.85
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M189.89 447.51L189.84 450.01L110.11 450.24V447.51H189.89Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.85
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M108.27 446.37H105.36L100.58 450.44L106.96 459.62H109.05V456.05L109 448.63H102.73",
    fill: "#131F2E"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M108.27 446.37H105.36L100.58 450.44L106.96 459.62H109.05V456.05L109 448.63H102.73",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M111.86 453.72H109.68V456.85H107.5V416.64H109.82L109.64 450.99H111.91L111.86 453.72Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.85
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M107.59 427.82C107.54 428.18 110.18 427.68 110.18 427.68C110.18 427.68 112.5 426.18 112.86 424.45C112.92 423.6 113.63 424.2 113.04 421.91C113.13 421.5 111.86 421.05 111.86 421.05C111.86 421.05 111.68 422.55 110.13 424.68C110.13 424.68 108.63 426.13 106.63 426.5C106.63 426.5 106.27 427.55 107.58 427.82H107.59Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.85
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M107.4 438.18H111.85L111.8 440.18H107.53L107.39 438.18H107.4Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.85
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M132.71 411.96H144.11L156.87 448.3L132.47 448.23L132.71 411.95V411.96Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.24
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M118.85 444.36L133.3 444.25V446.82H118.85V444.37V444.36Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.95
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M131.73 447.19H129V449.1H131.73V447.19Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.85
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M141.19 444.74H155V447.15H141.23L141.18 444.74H141.19Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.85
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M142.23 446.96H139.5V448.87H142.23V446.96Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.85
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M139.04 444.37H132.18V447.73H139.04V444.37Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.85
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M138.08 441.78H133.36V444.05H138.08V441.78Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.85
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M175.92 423.53V445.25H184.4V423.4L175.92 423.53Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.85
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M176.08 447.57H173.35V449.48H176.08V447.57Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.85
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M186.57 447.34H183.84V449.25H186.57V447.34Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.85
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M183.39 444.75H176.53V448.11H183.39V444.75Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.85
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M182.43 442.17H177.71V444.44H182.43V442.17Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.85
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M109.95 443.22L111.95 443.13V447.4H109.95V443.22Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.85
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M112.13 443.22H115.76V447.13H112.03L112.12 443.22H112.13Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.85
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M115.86 443.2L118.86 444.29V447.2H115.63L115.86 443.2Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.85
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M132.74 412.1V390.06L154.02 377.89L154.35 412.29L132.74 412.1Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.2
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M132.69 410.04L154.24 409.72L154.35 412.42L132.63 411.97L132.69 410.04Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.2
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M177.78 425.46C177.78 436.48 168.85 445.41 157.83 445.41C146.81 445.41 137.88 436.48 137.88 425.46C137.88 414.44 146.81 405.51 157.83 405.51C168.85 405.51 177.78 414.44 177.78 425.46Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M174.51 425.43C174.51 434.62 167.06 442.07 157.87 442.07C148.68 442.07 141.23 434.62 141.23 425.43C141.23 416.24 148.68 408.79 157.87 408.79C167.06 408.79 174.51 416.24 174.51 425.43Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M159.21 413.13C159.21 413.93 158.56 414.58 157.76 414.58C156.96 414.58 156.31 413.93 156.31 413.13C156.31 412.33 156.96 411.68 157.76 411.68C158.56 411.68 159.21 412.33 159.21 413.13Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M159.21 437.8C159.21 438.6 158.56 439.25 157.76 439.25C156.96 439.25 156.31 438.6 156.31 437.8C156.31 437 156.96 436.35 157.76 436.35C158.56 436.35 159.21 437 159.21 437.8Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M146.88 425.46C146.88 426.26 146.23 426.91 145.43 426.91C144.63 426.91 143.98 426.26 143.98 425.46C143.98 424.66 144.63 424.01 145.43 424.01C146.23 424.01 146.88 424.66 146.88 425.46Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M171.74 425.46C171.74 426.26 171.09 426.91 170.29 426.91C169.49 426.91 168.84 426.26 168.84 425.46C168.84 424.66 169.49 424.01 170.29 424.01C171.09 424.01 171.74 424.66 171.74 425.46Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M186.82 442.54H193.91H186.82Z",
    fill: "#131F2E"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M186.82 442.54H193.91",
    stroke: "#F7F9F9",
    strokeWidth: 1.28
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M135.73 443.87V454.59V443.87Z",
    fill: "#131F2E"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M135.73 443.87V454.59",
    stroke: "#F7F9F9",
    strokeWidth: 0.85
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M180.07 444.25V454.97V444.25Z",
    fill: "#131F2E"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M180.07 444.25V454.97",
    stroke: "#F7F9F9",
    strokeWidth: 0.85
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M274.5 370.94H272.14V373.35H274.5V370.94Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.85
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M274.41 368.71V374.25H277.64V368.84L274.41 368.7V368.71Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.85
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M540.6 442.9H253.7V469.5H540.6V442.9Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M528.73 442.9V469.5V442.9Z",
    fill: "#131F2E"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M528.73 442.9V469.5",
    stroke: "#F7F9F9"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M185.38 449.59V469.93V449.59Z",
    fill: "#131F2E"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M185.38 449.59V469.93",
    stroke: "#F7F9F9"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M244.63 449.48V470.04V449.48Z",
    fill: "#131F2E"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M244.63 449.48V470.04",
    stroke: "#F7F9F9"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M248.15 449.7V469.82V449.7Z",
    fill: "#131F2E"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M248.15 449.7V469.82",
    stroke: "#F7F9F9"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M110.45 256.93H105.17V312.57H110.45V256.93Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4798 314.23H76.0698V318H97.4798V314.23Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M93.75 375.53C95.86 382.47 104.61 382.24 107.02 375.68L108.15 371.31",
    fill: "#131F2E"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M93.75 375.53C95.86 382.47 104.61 382.24 107.02 375.68L108.15 371.31",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1799 469.17H93.6799L93.7599 374.32L80.1899 374.17V469.17H80.1799Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8299 469.32L90.6599 374.32H80.1799V469.24L90.8399 469.32H90.8299Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.08
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3699 371.08H76.1799V374.55H97.3699V371.08Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M113.02 317.25H62.2V371.69H113.02V317.25Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M110.75 320.71H64.46V368.21H110.75V320.71Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M77.12 359.83C77.12 363.19 74.52 365.92 71.31 365.92C68.1 365.92 65.5 363.19 65.5 359.83C65.5 356.47 68.1 353.74 71.31 353.74C74.52 353.74 77.12 356.47 77.12 359.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1898 359.85C89.1898 363.23 86.5898 365.97 83.3798 365.97C80.1698 365.97 77.5698 363.23 77.5698 359.85C77.5698 356.47 80.1698 353.73 83.3798 353.73C86.5898 353.73 89.1898 356.47 89.1898 359.85Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M101.25 359.81C101.25 363.16 98.6499 365.88 95.4399 365.88C92.2299 365.88 89.6299 363.16 89.6299 359.81C89.6299 356.46 92.2299 353.74 95.4399 353.74C98.6499 353.74 101.25 356.46 101.25 359.81Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M74.88 359.77C74.88 361.62 73.38 363.11 71.54 363.11C69.7 363.11 68.2 361.61 68.2 359.77C68.2 357.93 69.7 356.43 71.54 356.43C73.38 356.43 74.88 357.92 74.88 359.77Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M86.95 359.77C86.95 361.62 85.45 363.11 83.61 363.11C81.77 363.11 80.27 361.61 80.27 359.77C80.27 357.93 81.77 356.43 83.61 356.43C85.45 356.43 86.95 357.92 86.95 359.77Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0098 359.77C99.0098 361.62 97.5098 363.11 95.6698 363.11C93.8298 363.11 92.3298 361.61 92.3298 359.77C92.3298 357.93 93.8298 356.43 95.6698 356.43C97.5098 356.43 99.0098 357.92 99.0098 359.77Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M67.17 324.33H108.79C109.46 324.33 110 324.87 110 325.54V350.27C110 350.94 109.46 351.48 108.79 351.48H67.17C66.5 351.48 65.96 350.94 65.96 350.27V325.54C65.96 324.87 66.5 324.33 67.17 324.33Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M108.34 327.2H67.9299V349.22H108.34V327.2Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M104.42 312.27H111.96C112.63 312.27 113.17 312.81 113.17 313.48V315.89C113.17 316.56 112.63 317.1 111.96 317.1H104.42C103.75 317.1 103.21 316.56 103.21 315.89V313.48C103.21 312.81 103.75 312.27 104.42 312.27Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M105.93 249.54H110.45C111.78 249.54 112.86 250.62 112.86 251.95V255.12C112.86 256.45 111.78 257.53 110.45 257.53H105.93C104.6 257.53 103.52 256.45 103.52 255.12V251.95C103.52 250.62 104.6 249.54 105.93 249.54Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M103.51 253.01H75.77",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M100.2 238.53V266.88",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M96.28 241.02V264.54",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3198 244.07V261.64",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M88.47 247.73V259.3",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8499 250.14V255.83",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5898 251.35V254.82",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReverseMark);
export default __webpack_public_path__ + "static/media/reverse-mark.a5ddc263794b6f8cd1b3b19fe919a071.svg";
export { ForwardRef as ReactComponent };